import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';

@Injectable({ providedIn: 'root' })
export class RecruitmentApplicationService {

  url = ConfigService.toApiUrl('recruitment-applications/');

  constructor(private http: HttpClient) {}

  getByOffer(offerId: any) {
    let suffix = offerId ? `?offer_id=${offerId}` : '';
    return this.http.get<any>(`${ConfigService.toApiUrl('recruitment-applications')}${suffix}`, ConfigService.addAction('list'));
  }

  get(id: any) {
    return this.http.get<any>(`${this.url}${id}`, ConfigService.addAction('show'));
  }

  delete(id: any) {
    return this.http.delete<any>(`${this.url}${id}`, ConfigService.addAction('delete'));
  }

  setState(id: any, state: any, extra: any = {}) {
    return this.http.get<any>(`${ConfigService.toApiUrl('recruitment-applications-set-state')}/${id}/state/${state}`, ConfigService.addAction('status'));
  }

  setStateWithBody(id: any, state: any, extra: any = {}) {
    return this.http.post<any>(`${ConfigService.toApiUrl('recruitment-applications-set-state')}/${id}/state/${state}`, extra, ConfigService.addAction('status'));
  }

  hire(id: any) {
    return this.http.post<any>(`${ConfigService.toApiUrl('recruitment-applications-hire')}/${id}`, {}, ConfigService.addAction('add'));
  }

  // Public endpoint (no auth) — multipart submission
  apply(formData: FormData) {
    return this.http.post<any>(`${ConfigService.toApiUrl('recruitment-apply')}`, formData);
  }
}
